import { render, staticRenderFns } from "./LegacyImportationForm.vue?vue&type=template&id=8ce10bf2"
import script from "./LegacyImportationForm.vue?vue&type=script&lang=js"
export * from "./LegacyImportationForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports